import React from "react";

import domikLoading from "../../content/images/domikloading.gif"; // Tell webpack this JS file uses this image

export const DomikLoading = () => {
  return <img src={domikLoading} alt="Loading image" />;
};
